let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("SOyPJ")).then(() => parcelRequire('9sgM8'));